module.exports = __webpack_public_path__ + "img/1-4.ff6f3a7d.svg";